// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ceFa","importantInfo":"styles_importantInfo__363l-"};